export default {
  title: 'Facturen',
  form: {
    auto_generate_invoices: {
      label: 'Facturen automatisch genereren',
    },
  },
  buttons: {
    save: 'Opslaan',
  },
  toasts: {
    failed_to_save_changes: 'Opslaan van wijzigingen mislukt',
    changes_got_saved: 'Wijzigingen opgeslagen',
  },
};
